import React, { ComponentProps, FC } from 'react'

import clsx from 'clsx'

import { Txt, FontSizeType, LetterType, Icon } from 'src/components/atoms'

type UnderlineType = 'onlyDefault' | 'onlyHover'

type Props = {
  sizeType?: FontSizeType
  children: React.ReactNode
  tag?: ComponentProps<typeof Txt>['tag']
  prependIconPath?: string
  appendIconPath?: string
  underlineType?: UnderlineType
  letterType?: LetterType
  disabled?: boolean
  className?: string
  onClick?: () => void
}

export const LinkTxt: FC<Props> = ({
  sizeType,
  children,
  tag,
  prependIconPath,
  appendIconPath,
  underlineType = 'onlyHover',
  letterType,
  disabled = false,
  className,
  onClick,
}) => {
  return (
    <span role="presentation" onClick={onClick}>
      <span
        className={clsx(
          'tw-inline-flex tw-centering',
          disabled ? 'tw-cursor-default' : 'tw-cursor-pointer',
          disabled && 'tw-opacity-40'
        )}
      >
        {prependIconPath && (
          <Icon
            size="--r0"
            path={prependIconPath}
            className="tw-mr-r-3 tw-text-standardText-secondary"
          />
        )}
        <span>
          <Txt
            tag={tag}
            sizeType={sizeType}
            letterType={letterType}
            className={clsx(
              underlineType === 'onlyDefault'
                ? 'tw-underline'
                : disabled
                ? 'tw-no-underline'
                : 'tw-no-underline hover:tw-underline',
              className
            )}
          >
            {children}
          </Txt>
        </span>
        {appendIconPath && (
          <Icon
            size="--r0"
            path={appendIconPath}
            className="tw-ml-r-3 tw-text-standardText-secondary"
          />
        )}
      </span>
    </span>
  )
}
